const styles = theme => ({
    dataGrid: {
        border: `1px solid ${theme.AppBGColor}`,
        "& .gridCell-greenBackground": {
            background: `rgba(54, 181, 178, 0.1)`,
            margin: '5px'
        },
        "& .gridCell-lightgreen": {
            background: `rgba(54, 181, 178, 0.1)`,
        },
        "& .dispatch-grid-disable-button":{
            color: theme.iconColor,
            border: `0.5px solid ${theme.iconColor}`,
        },
        
        "& .dispatch-grid-active-button":{    
            color: theme.palette.primary.main,
            border: `0.5px solid ${theme.palette.primary.main}`
        },
    }
})
export default styles;